module.exports = __webpack_public_path__ + "8e76e6e8a2c665c1a65ab6bc83045ca6.jpg";